import { IconProps } from '@/libs/types'
import React from 'react'

const AlertIcon: React.FC<IconProps> = ({ color = '#CC6633' }) => {
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.3851 1.64824C10.532 -0.39072 13.4676 -0.390721 14.6146 1.64823L22.985 16.529C24.1099 18.5289 22.6648 20.9998 20.3703 20.9998H3.62937C1.33489 20.9998 -0.110254 18.5289 1.01464 16.529L9.3851 1.64824ZM13.4997 16.5C13.4997 17.3284 12.8281 18 11.9997 18C11.1713 18 10.4997 17.3284 10.4997 16.5C10.4997 15.6716 11.1713 15 11.9997 15C12.8281 15 13.4997 15.6716 13.4997 16.5ZM11.9997 4.5C11.1713 4.5 10.4997 5.17157 10.4997 6V10.5C10.4997 11.3284 11.1713 12 11.9997 12C12.8281 12 13.4997 11.3284 13.4997 10.5V6C13.4997 5.17157 12.8281 4.5 11.9997 4.5Z"
        fill={color}
      />
    </svg>
  )
}

export default AlertIcon
